<template><svg class="ico ico__alert" width="800" height="800" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Alert">
  <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
    <path d="M12 8v4M12 16h0"/>
    <circle cx="12" cy="12" data-name="--Circle" r="10"/>
  </g>
</svg>
</template>